// extracted by mini-css-extract-plugin
module.exports = {"react-tabs":"styles_react-tabs__VAXIK","react-tabs__tab-list":"styles_react-tabs__tab-list__1_IoS","react-tabs__tab--selected":"styles_react-tabs__tab--selected__3UASw"};